var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1624520322265,
    className: "icon",
    viewBox: "0 0 1092 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5174,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213.28125,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1015.808 0c23.210667 0 45.192533 10.8544 59.733333 29.4912 26.350933 33.860267 21.026133 83.285333-11.946666 110.3872l-344.2688 283.101867v522.4448c0 11.605333-2.525867 23.210667-7.441067 33.655466l-0.4096 0.955734c-18.568533 38.912-64.375467 55.022933-102.263467 35.908266l-187.050666-94.276266a85.674667 85.674667 0 0 1-46.557867-76.663467v-421.888L28.8768 140.014933A79.394133 79.394133 0 0 1 0 79.325867v-0.750934C0 35.157333 34.2016 0 76.458667 0h939.349333z m-66.3552 102.468267H143.1552l295.7312 241.390933c22.801067 18.568533 36.181333 46.762667 36.4544 76.663467v413.832533l144.247467 72.704V421.341867c0-29.764267 12.970667-58.026667 35.498666-76.8l0.682667-0.546134L949.4528 102.4z m54.613333 692.087466a50.517333 50.517333 0 0 1 49.834667 51.2 50.517333 50.517333 0 0 1-49.834667 51.268267h-179.541333a50.517333 50.517333 0 0 1-49.834667-51.2 50.517333 50.517333 0 0 1 49.834667-51.2h179.541333z m0-174.216533a50.517333 50.517333 0 0 1 49.834667 51.2 50.517333 50.517333 0 0 1-49.834667 51.268267h-179.541333a50.517333 50.517333 0 0 1-49.834667-51.2 50.517333 50.517333 0 0 1 49.834667-51.2h179.541333z m0-170.734933a50.517333 50.517333 0 0 1 49.834667 51.2 50.517333 50.517333 0 0 1-49.834667 51.2h-179.541333a50.517333 50.517333 0 0 1-49.834667-51.2 50.517333 50.517333 0 0 1 49.834667-51.2h179.541333z",
    "p-id": 5175
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7734e5ea.svg";
export { ForwardRef as ReactComponent };